module.exports = __webpack_public_path__ + "img/指下.dd8b0566.png";